<template>
    <div :class="(message.fromId === user.id) ? 'ml-8 self-end' : 'mr-8 self-start'"
         class="max-w-sm mb-4">
        <div
            :class="(message.fromId === user.id?'bg-brand border-brand-dark text-white':'bg-gray-50 border-gray-300 text-brand') + (message.highlight?' animate-highlight':'')"
            class="rounded-xl border px-3 py-2 flex flex-row last:mb-0 max-w-md transition-colors duration-75 ease-in"
        >
            <div class="relative w-full">
                <div class="flex" :class="(message.fromId === user.id) ? 'text-white' : 'text-gray-700'">
                    <div class="text-xs font-bold flex-grow">{{ message.from }}</div>
                    <div class="flex-shrink text-xs opacity-50 hover:opacity-100 ml-2"
                         v-if='message.type==="INBOUND_EMAIL"'
                         @click="$emit('viewEmail',message)"><i class="fas fa-envelope"/></div>
                    <div class="flex-shrink text-xs opacity-50 hover:opacity-100 ml-2"
                         @click="$emit('replyingTo',message)"><i class="fa fa-reply"/></div>
                </div>
                <message-widget-quoted v-if="message.replyTo" :message="message.replyTo"
                                       @click="$emit('messageClicked',message.replyTo.id)"></message-widget-quoted>
                <div class="whitespace-pre-wrap truncate"
                     :class="(message.fromId === user.id) ? 'text-white' : 'text-gray-700'"
                     v-html="highlightMessage(message.message)"
                ></div>
                <div v-if="message.attachments && message.attachments.length" class="mt-2">
                    <div v-for="linkObject in message.attachments.filter((i) => i.type==='LINK')">
                        <a :class="(message.fromId === user.id) ? 'text-white hover:text-gray-50' : 'text-gray-700 hover:text-brand'"
                           class="text-xs font-bold" @click="goLink(linkObject.url)" href="javascript:void(0)"><i
                            class="fas fa-link mr-1"></i>
                            <span v-html="highlightMessage(linkObject.title)"></span>
                        </a>
                    </div>
                    <div v-for="ob in message.attachments.filter((i) => i.type!=='ACTIONABLE')">
                        <a v-if="ob.type==='DEFECT'"
                           :class="(message.fromId === user.id) ? 'text-white hover:text-gray-50' : 'text-gray-700 hover:text-brand'"
                           class="text-xs font-bold" @click="goLink(messageUrl(message.id),true)"
                           href="javascript:void(0)"><i
                            class="fas fa-fragile mr-1"></i>
                            <span
                                v-html="highlightMessage(ob.reference ? ('Defect #' + ob.reference) : ob.name)"></span>
                        </a>
                        <a v-else-if="ob.type==='NON_CONFORMANCE_REPORT'"
                           :class="(message.fromId === user.id) ? 'text-white hover:text-gray-50' : 'text-gray-700 hover:text-brand'"
                           class="text-xs font-bold" @click="goLink(messageUrl(message.id),true)"
                           href="javascript:void(0)"><i
                            class="fas fa-exclamation-triangle mr-1"></i>
                            <span
                                v-html="highlightMessage(ob.reference ? ('NCR #' + ob.reference) : ob.name)"></span>
                        </a>
                        <a v-else-if="ob.type==='PURCHASE_ORDER'"
                           :class="(message.fromId === user.id) ? 'text-white hover:text-gray-50' : 'text-gray-700 hover:text-brand'"
                           class="text-xs font-bold" @click="goLink(messageUrl(message.id),true)"
                           href="javascript:void(0)"><i
                            class="fas fa-pound-sign mr-1"></i>
                            <span
                                v-html="highlightMessage(ob.reference ? ('Purchase Order #' + ob.reference) : ob.name)"></span>
                        </a>
                        <a v-else-if="ob.type==='TOOLBOX_TALK'"
                           :class="(message.fromId === user.id) ? 'text-white hover:text-gray-50' : 'text-gray-700 hover:text-brand'"
                           class="text-xs font-bold" @click="goLink(messageUrl(message.id),true)"
                           href="javascript:void(0)"><i
                            class="fas fa-toolbox mr-1"></i>
                            <span
                                v-html="highlightMessage('Toolbox Talk #' + ob.title)+' ('+ob.date+')'"></span>
                        </a>
                        <a v-else-if="ob.type==='DAILY_BRIEFING'"
                           :class="(message.fromId === user.id) ? 'text-white hover:text-gray-50' : 'text-gray-700 hover:text-brand'"
                           class="text-xs font-bold" @click="goLink(messageUrl(message.id),true)"
                           href="javascript:void(0)"><i
                            class="fas fa-exclamation-triangle mr-1"></i>
                            <span
                                v-html="highlightMessage('Daily Briefing #' + ob.packageReference)+ ' ('+ob.date+')'"></span>
                        </a>
                        <a v-else-if="ob.type==='PPE_REGISTER'"
                           :class="(message.fromId === user.id) ? 'text-white hover:text-gray-50' : 'text-gray-700 hover:text-brand'"
                           class="text-xs font-bold" @click="goLink(messageUrl(message.id),true)"
                           href="javascript:void(0)"><i
                            class="fas fa-hard-hat mr-1"></i>
                            <span
                                v-html="highlightMessage('PPE Register #' + ob.packageReference)+ ' ('+ob.date+')'"></span>
                        </a>
                    </div>
                    <div v-for="linkObject in message.attachments.filter((i) => i.type==='ACTIONABLE')" class="flex">
                        <a :class="(message.fromId === user.id) ? 'text-white hover:text-gray-50' : 'text-gray-700 hover:text-brand'"
                           class="flex items-center text-xs font-bold" @click="goLink(linkObject.url)"
                           href="javascript:void(0)">
                            <span class="flex-1">
                                <i class="mr-1 " :class="classMap(linkObject.actionableType)"></i>
                                <span v-html="highlightMessage(linkObject.title)"></span>
                            </span>
                            <span v-if="linkObject.actionable">
                                <i class="fas bg-gray-50 rounded-full p-1 ml-1"
                                   :class="(linkObject.actionedAt?'fa-check text-green-500':'fa-info-circle text-red-500')"></i>
                            </span>
                        </a>
                    </div>
                    <div v-for="linkObject in message.attachments.filter((i) => i.type==='INBOUND_FILE')" class="flex">
                        <a :class="(message.fromId === user.id) ? 'text-white hover:text-gray-50' : 'text-gray-700 hover:text-brand'"
                           class="inline-block rounded-lg bg-white border border-gray-200 px-2 py-0.5 m-0.5 items-center text-xs"
                           href="javascript:void(0)" @click="goInboundFile(linkObject.index)">
                            <span class="inline-block">
                                <i class="mr-1 fas fa-file"></i>
                                <span v-html="highlightMessage(linkObject.name)"></span>
                            </span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div :class="(message.fromId === user.id) ? 'text-right' : 'text-left'" class="mt-1.5 text-xs">
                    <span :title="message.createdAtFormatted"
                          class="inline-block text-gray-400 hover:text-gray-500 cursor-help"
                          v-text="message.createdAtFormatted"></span>
            <ui-dropdown menu-class="px-4 py-2 w-72" :placement="'bottom'"
                         v-if="(message.fromId === user.id) && (channel.source !== user.id)"
                         class="inline-block">
                <template #default="{ toggle, open, close}">
                            <span v-if="message.statusLogs.length && (channel.type==='GROUP')" @mouseover="open"
                                  @mouseout="close"
                                  class="inline-block ml-1 opacity-100 bg-white rounded-xl p-1"
                                  :class="hasBeenRead(message) === message.statusLogs.length?'text-green-400':'text-gray-400'">
                               <i class="fa fa-check" style="font-size:9px"/>
                            </span>
                    <span
                        v-else-if="message.statusLogs.length && message.statusLogs.find((i) => i.who === user.id) && message.statusLogs.find((i) => i.who === user.id).sentAt"
                        @mouseover="open"
                        @mouseout="close"
                        class="inline-block ml-1 opacity-100 bg-white rounded-xl p-1"
                        :class="hasBeenRead(message) === message.statusLogs.length?'text-green-400':'text-gray-400'">
                               <i class="fa fa-check" style="font-size:9px"/>
                            </span>
                    <span v-else
                          class="inline-block ml-1 opacity-10 bg-white rounded-xl p-1">
                               <i class="fa fa-check" style="font-size:9px"/>
                            </span>
                </template>
                <template #menu="{ close }">
                    <div class="flex-1 flex items-center min-w-0 relative mb-1"><p
                        class="text-sm text-brand font-semibold">Message Log</p></div>
                    <message-widget-user-avatar
                        class="flex-1 flex items-center min-w-0 relative w-full"
                        v-for="log in message.statusLogs"
                        v-if="channel.members.find((i) => i.id === log.who && i.id != user.id)"
                        :key="log.who"
                        :contacts="contacts"
                        :avatar="channel.members.find((i) => i.id === log.who).avatarUrl"
                        :member-id="log.id"
                    >
                        <div class="w-full">
                            <div class="ml-4 flex">
                                <p class="text-xs font-medium text-gray-600 truncate">
                                    <span v-text="channel.members.find((i) => i.id === log.who).name"></span>
                                </p>
                            </div>
                            <div class="ml-4 flex justify-end">
                                <p class="text-xs font-medium text-gray-400 truncate">
                                    Sent At: <span v-text="log.sentAt" v-if="log.sentAt"
                                                   class="text-brand"></span>
                                    <span v-else class="text-gray-500">-- Not yet sent --</span>

                                </p>
                            </div>
                            <div class="ml-4 flex justify-end">
                                <p class="text-xs font-medium text-gray-400 truncate">
                                    Viewed At:
                                    <span v-text="log.viewedAt" v-if="log.viewedAt"
                                          class="text-brand"></span>
                                    <span v-else class="text-gray-500">-- Not yet viewed --</span>
                                </p>
                            </div>
                        </div>
                    </message-widget-user-avatar>
                    <message-widget-user-avatar
                        class="flex-1 flex items-center min-w-0 relative w-full"
                        v-for="log in message.statusLogs"
                        v-if="!channel.members.find((i) => i.id === log.who)"
                        :key="log.who"
                    >
                        <div class="w-full">
                            <div class="ml-4 flex">
                                <p class="text-xs font-medium text-gray-600 truncate">
                                    <span v-text="log.who"></span>
                                </p>
                            </div>
                            <div class="ml-4 flex justify-end">
                                <p class="text-xs font-medium text-gray-400 truncate">
                                    Sent At: <span v-text="log.sentAt" v-if="log.sentAt"
                                                   class="text-brand"></span>
                                    <span v-else class="text-gray-500">-- Not yet sent --</span>

                                </p>
                            </div>
                            <div class="ml-4 flex justify-end">
                                <p class="text-xs font-medium text-gray-400 truncate">
                                    Viewed At:
                                    <span v-text="log.viewedAt" v-if="log.viewedAt"
                                          class="text-brand"></span>
                                    <span v-else class="text-gray-500">-- Not yet viewed --</span>
                                </p>
                            </div>
                        </div>
                    </message-widget-user-avatar>
                </template>
            </ui-dropdown>
        </div>
    </div>
</template>

<script>

import UiDropdown from "../../ui/UiDropdown.vue";
import UiDropdownItem from "../../ui/UiDropdownItem.vue";
import MessageWidgetChannelAvatars from "./MessageWidgetChannelAvatars.vue";
import MessageWidgetUserAvatar from "./MessageWidgetUserAvatar.vue";
import UiDropdownDivider from "../../ui/UiDropdownDivider.vue";
import MessageWidgetQuoted from "./MessageWidgetQuoted.vue";
import {Message} from "@models";

export default {
    components: {
        MessageWidgetQuoted,
        UiDropdownDivider,
        MessageWidgetUserAvatar,
        MessageWidgetChannelAvatars,
        UiDropdownItem, UiDropdown,
    },
    props: {
        user: Object,
        channel: Object,
        contacts: [],
        message: Object,
        highlight: String,
    },
    data() {
        return {}
    },
    computed: {},
    methods: {
        async goInboundFile(index) {
            let message = await Message.find(this.channel.id, this.message.id, true);

            const b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
                const byteCharacters = atob(b64Data);
                const byteArrays = [];

                for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                    const slice = byteCharacters.slice(offset, offset + sliceSize);

                    const byteNumbers = new Array(slice.length);
                    for (let i = 0; i < slice.length; i++) {
                        byteNumbers[i] = slice.charCodeAt(i);
                    }

                    const byteArray = new Uint8Array(byteNumbers);
                    byteArrays.push(byteArray);
                }

                let blob = new Blob(byteArrays, {type: contentType});
                return blob;
            }


            let file = new File([b64toBlob(message.email.attachments[index].content)], message.email.attachments[index].name, {type: message.email.attachments[index].contentType});
            // Create a link and set the URL using `createObjectURL`
            let link = document.createElement("a");
            link.style.display = "none";
            link.href = URL.createObjectURL(file);
            link.download = file.name;

            // It needs to be added to the DOM so it can be clicked
            document.body.appendChild(link);
            link.click();

            // To make this work on Firefox we need to wait
            // a little while before removing it.
            setTimeout(() => {
                URL.revokeObjectURL(link.href);
                link.parentNode.removeChild(link);
            }, 0);


        },
        goLink(url, newWindow = false) {
            let w = window;
            if (w.parent) {
                w = w.parent
            }
            if (newWindow) {
                w.open(url, '_blank').focus();
            } else {
                w.document.location.href = url;
            }
        },
        classMap(type) {
            let ops = {
                'DEFECT': 'fas fa-fragile',
                'NON_CONFORMANCE_REPORT': 'fas fa-exclamation-triangle',
                'PURCHASE_ORDER': 'fas fa-pound-sign ',
                'TOOLBOX_TALK': 'fas fa-toolbox',
                'TOOLBOX_TALK_ATTENDANCE_SIGNATURE': 'fas fa-toolbox',
                'DAILY_BRIEFING': 'fas fa-exclamation-triangle',
                'PPE_REGISTER': 'fas fa-hard-hat',
            }
            let ret = 'fas fa-info-circle'
            return ops[type] ? ops[type] : ret
        },
        highlightMessage(text) {
            if (this.highlight) {
                return text.replace(new RegExp(this.highlight.trim().replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&'), 'ig'), '<span class="text-gray-700 bg-yellow-100 ">' + '$&' + '</span>')
            }
            return text
        },
        messageUrl(messageId) {
            if (this.channel.id) {
                return route('mobile.message', {channelId: this.channel.id, messageId: messageId})
            }
            return '#';
        },
        hasBeenRead(message) {
            return message.statusLogs.filter((i) => i.viewedAt).length
        },
    }
}
</script>

<style lang="scss" scoped>
.animate-highlight {
    animation: highli 280ms ease-in 3;
    @keyframes highli {
        0%, 50% {
            transform: translate(0px, 0px) scale(1);
        }
        0% {
            opacity: 1;
        }
        50% {
            opacity: 0.6;
        }
        25% {
            transform: translate(-5px, 0px);
        }
        75% {
            transform: translate(5px, 0px);
        }
    }
}
</style>